import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';

function LoadingButton(props) {
    return (
        <Button variant={props.variant} className={props.className} onClick={props.onClick} type={props.type} form={props.form} disabled={props.isLoading || props.disabled}>
            { props.isLoading ?
                <>
                    <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/>
                    <span className="visually-hidden">{props.children}</span>
                </>
                :
                props.children
            }
        </Button>
    );
};

export default LoadingButton;